import HttpRequest from "./http_request";

class WebPortalProvider extends HttpRequest {
  SignIn(data) {
    return this.post_guest("/api/auth/login", data);
  }
  SignOut(data) {
    return this.post("/api/auth/logout", data);
  }
  ForgotPassword(data) {
    return this.post_guest("/api/auth/forgotpassword", data);
  }
  ResetPassword(data) {
    return this.post_guest("/api/auth/resetpassword", data);
  }

  resetPasswordNumber(data) {
    return this.post("number/resetpassword", data);
  }

  GetProfile(data) {
    return this.post("profile", data);
  }

  ChangeProfile(data) {
    return this.post("profile/change", data);
  }

  ChangePassword(data) {
    return this.post("profile/password/change", data);
  }

  AuthCreate(data) {
    return this.post("v2/user/create", data);
  }

  AuthUpdate(data) {
    return this.post("v2/user/update", data);
  }
  AuthDelete(data) {
    return this.post("user/delete", data);
  }
  AuthList(data) {
    return this.post("v2/user", data);
  }

  CorpCreate(data) {
    return this.post("v2/corporate/create", data);
  }
  CorpUpdate(data) {
    return this.post("v2/corporate/update", data);
  }
  CorpRename(data) {
    return this.post("v2/corporate/rename", data);
  }
  CorpDelete(data) {
    return this.post("v2/corporate/delete", data);
  }
  CorpList(data) {
    return this.post("v2/corporate", data);
  }

  PackageCreate(data) {
    return this.post("package/create", data);
  }
  PackageUpdate(data) {
    return this.post("package/update", data);
  }
  PackageDelete(data) {
    return this.post("package/delete", data);
  }
  PackageList(data) {
    return this.post("package", data);
  }

  PilotNumberCreate(data) {
    return this.post("v2/number/pilot/create", data);
  }
  PilotNumberUpdate(data) {
    return this.post("number/pilot/update", data);
  }
  PilotNumberDelete(data) {
    return this.post("v2/number/pilot/delete", data);
  }
  PilotNumberList(data) {
    return this.post("v2/number/pilot", data);
  }
  PilotNumberListByEnterprise(data) {
    return this.post("v2/numberbyenterprise/pilot", data);
  }

  MappingNumberCreate(data) {
    return this.post("v2/number/mapping/create", data);
  }
  MappingNumberUpdate(data) {
    return this.post("v2/number/mapping/update", data);
  }
  MappingNumberDelete(data) {
    return this.post("v2/number/mapping/delete", data);
  }
  MappingNumberList(data) {
    return this.post("v2/number/mapping", data);
  }

  ComProtalLogin(data) {
    return this.post("number/comportal", data);
  }
  SyncPackage(data) {
    return this.postJson("number/packagesync", data);
  }

  NumberCreate(data) {
    return this.post("v2/number/create", data);
  }
  NumberUpdate(data) {
    return this.post("v2/number/update", data);
  }
  NumberDelete(data) {
    return this.post("v2/number/delete", data);
  }
  NumberList(data) {
    return this.post("v2/number", data);
  }
  NumberListByEnterprise(data) {
    return this.post("v2/numberbyenterprise", data);
  }

  NumberImportList(data) {
    return this.post("number/import/list", data);
  }

  NumberImport(data) {
    return this.postFile("number/import/file", data);
  }

  ClearNumberImport(data) {
    return this.post("number/import/clear", data);
  }

  MlhgCreate(data) {
    return this.post("v2/mlhg/create", data);
  }
  MlhgUpdate(data) {
    return this.post("v2/mlhg/rename", data);
  }
  MlhgDelete(data) {
    return this.post("v2/mlhg/delete", data);
  }
  MlhgList(data) {
    return this.post("v2/mlhg", data);
  }

  MlhgNumberAdd(data) {
    return this.post("v2/mlhg/member/add", data);
  }
  MlhgNumberDelete(data) {
    return this.post("v2/mlhg/member/delete", data);
  }
  MlhgNumberList(data) {
    return this.post("v2/mlhg/member", data);
  }

  // voice mail
  VoicemailSync(data) {
    return this.post("voicemailsync", data);
  }

  VoicemailList(data) {
    return this.post("voicemail", data);
  }

  // CDR
  ReportCdr(data) {
    return this.post("v2/report/cdr", data);
  }

  ReportDashboard(data) {
    return this.post("v2/report/dashboard", data);
  }

  ReportCDRGet(data) {
    return this.post("v3/report/cdr", data);
  }
  ReportDashboardGet(data) {
    return this.post("v3/report/dashboard", data);
  }
  ReportSummaryGet(data) {
    return this.post("v3/report/summary", data);
  }
}

export default WebPortalProvider;
